import { inject, bindable, BindingEngine } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { MachineService } from 'pages/standard-setup/machines/service';
import { StageService } from 'pages/system-fields/stages/service';
import { UnitOfMeasurementService } from 'pages/system-fields/unit-of-measurements/service';
import { QuoteService } from 'pages/quotes/service';
import { BindingSignaler } from 'aurelia-templating-resources';
import toastr from 'toastr';

@inject(DialogController, EventAggregator, DialogService, MachineService, ProcessService, StageService, UnitOfMeasurementService, QuoteService, BindingSignaler, BindingEngine)
export class QuoteProcessesEditor {
    @bindable quoteProcesses;

    constructor(controller, ea, dialogService, machineService, processService, stageService, unitOfMeasurementService, quoteService, bindingSignaler, bindingEngine) {
        this.controller = controller;
        this.ea = ea;
        this.dialogService = dialogService;
        this.machineService = machineService;
        this.processService = processService;
        this.stageService = stageService;
        this.unitOfMeasurementService = unitOfMeasurementService;
        this.quoteService = quoteService;
        this.showEdit = false;
        this.signaler = bindingSignaler;

        this.item = {};

        bindingEngine
        .propertyObserver(this.item, 'stageId')
        .subscribe(async (newValue, oldValue) => {
          await this.applyProcessPrice();
        });

        bindingEngine
        .propertyObserver(this.item, 'machineId')
        .subscribe(async (newValue, oldValue) => {
          await this.applyProcessPrice();
        });

        bindingEngine
        .propertyObserver(this.item, 'processId')
        .subscribe(async (newValue, oldValue) => {
           await this.applyProcessPrice();
        });
    }

    async activate(item) {
      if (item != undefined) {
        this.quoteProcesses = item.quoteProcesses;
        this.quote = item.quote;

        const volume = this.quote.volumePerMonth ? this.quote.volumePerMonth : 0;
        if (item.index != null) {
          this.item = JSON.parse(JSON.stringify(this.quoteProcesses[item.index]));
        } else if (this.quoteProcesses.length > 0) {
          this.item = {...this.quoteProcesses[this.quoteProcesses.length - 1]};
          this.item.id = 0;
        }
        else {
          this.item.workCenter = "STAMPING";
        }

        this.item.override = false;
        this.item.quantity = 0;
        this.item.unitPrice = 0;
        this.item.isAdded = !item.isEdit;
        this.item.isEdit = item.isEdit;
        this.item.quoteId = this.quote.id;
        this.item.deleted = false;
        this.item.stampingStandardId = this.quote.stampingStandard.standardId;
        this.item.weldingStandardId =  this.quote.weldingStandard.standardId;
        this.item.partSizeId = this.quote.partSizeId;
        this.item.volumePerMonth = volume;

        if (this.item.isAdded) {
          if (this.item.processName === "TRANSFER") {
            this.item.numberOrQuantity = 0;
          }
          await this.applyProcessPrice();
        }
      }
    }

    attached() {
      this.uxBody.querySelector("#workCenter").focus();
    }

    changeWorkCenter() {      
      this.item.processName = "";
      this.item.processId = "";
      this.processSelect.select.clear(true);
      this.item.machineId = "";
      this.item.machineName = "";
      this.machineSelect.select.clear(true);
      this.item.stageName = "";
      this.item.stageId = "";
      this.stageSelect.select.clear(true);
      this.item.useGangFactor = false;
    }

    addProcess () {
      this.dialogService.open({ viewModel: this.processService.editor });
    }

    addMachine() {
      this.dialogService.open({ viewModel: this.machineService.editor });
    }

    addStage() {
      this.dialogService.open({ viewModel: this.stageService.editor });
    }

    addUnitOfMeasurement () {
      this.dialogService.open({ viewModel: this.unitOfMeasurementService.editor });
    }

    async getProcessPrice() {
      if (this.item.processId && this.item.volumePerMonth && this.item.workCenter != "OTHER") {
        const standardId = this.item.workCenter == "STAMPING" ? this.item.stampingStandardId : this.item.weldingStandardId;
        const prices = this.item.workCenter == "STAMPING" ? await this.quoteService.getStampProcessPrices(standardId, this.item.processId, this.item.machineId) : 
                        await this.quoteService.getWeldProcessPrices(standardId, this.item.processId, this.item.quoteId, this.item.partSizeId);
        if (prices.length > 0) {
          const comparisonQty = this.item.workCenter == "STAMPING" || prices.some(x => x.isVolumePerMonth) ? this.item.volumePerMonth : this.item.numberOrQuantity;
          const price = prices.find(x => comparisonQty >= x.min && (comparisonQty <= x.max || x.max == null));
          return price.unitPrice;
        }
        else {
          return 0;
        }
      }
      return 0;
    }

    async updateUnitPrice() {
      const price = await this.getProcessPrice();
      if (price != this.item.unitPrice) {
        this.item.override = true;
      }
    }

    async applyProcessPrice() {
      const price = await this.getProcessPrice();
      this.item.unitPrice = price;
      this.item.override = false;
    }

    save(add) {
      this.item.isContinueAdd = false;
      if (!this.item.stageId) {
        this.item.stageName = "";
      }
      else {
        let count = this.quoteProcesses.filter((obj) => {
          return obj.stageId == this.item.stageId
        }).length;
        if (this.item.isAdded) count++;
      }
      
      if (!this.item.unitPrice) {
        this.item.unitPrice = 0;
      }
      
      if (!this.item.machineId) {
        toastr.error("You must enter a machine before saving a process");
        return;
      }

      if (add) {
        this.item.isContinueAdd = true;
      }
      
      this.controller.ok(this.item);
    }
}
